import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./theme/default.css";
import App from "./App";
import { loadAppConfig } from "./utils/loadAppConfig";

async function startApp() {
  await loadAppConfig();

  const root = createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

startApp();